<template>
  <div class="resolution-shell">
    <div
      class="boxGrid resolution-feed"
      :style="{
        overflowX: 'none',
        overflowY: 'auto',
        maxHeight: typeof altura == 'undefined' ? '35vh' : altura + 'vh',
      }"
    >
        <v-card class="resolution-list">
          <v-card-text>
            <div v-if="displayedResolucoes.length === 0" class="resolution-empty">
              Nenhum retorno informado
            </div>
            <div v-for="(i, idx) in displayedResolucoes" :key="resolutionKey(i, idx)">
              <div
                :class="[
                'resolution-message',
                { 'resolution-message--self': i.idtec == getUser.id },
              ]"
            >
              <div class="resolution-message__avatar">
                <FotoUser :id="i.idtec" :tecnicos="tecnicos"></FotoUser>
              </div>

              <div class="resolution-message__content">
                <div class="resolution-message__meta-row">
                  <small class="resolution-item__meta">
                    <strong>{{ i.datac + " - " + i.horac }}</strong>
                  </small>
                </div>

                <div v-if="editingId === i.id" class="resolution-edit">
                  <div class="resolution-edit__editor">
                    <vue-editor
                      id="editor_retorno_edicao"
                      v-model="editingText"
                    ></vue-editor>
                  </div>

                  <div class="resolution-edit__actions">
                    <v-btn text small color="grey darken-1" @click="cancelaEdicao">
                      Cancelar
                    </v-btn>
                    <v-btn
                      small
                      color="primary"
                      :loading="savingEdit"
                      @click="salvaEdicao(i)"
                    >
                      Salvar
                    </v-btn>
                  </div>
                </div>

                <div v-else class="resolution-message__body">
                  <v-menu
                    v-if="i.idtec == getUser.id"
                    offset-y
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="resolution-message__menu"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon size="18">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense class="resolution-message__dropdown">
                      <v-list-item @click.stop="iniciaEdicao(i)">
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click.stop="excluirResolucao(i)">
                        <v-list-item-title>Excluir</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <div class="resolution-message__bubble">
                    <div class="resolution-item__text" v-html="i.text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <vs-divider></vs-divider>

    <div class="resolution-composer">
      <div class="resolution-composer__box">
        <div class="resolution-composer__editor">
          <vue-editor id="editor_retorno" v-model="res.text"></vue-editor>
        </div>
        <v-btn
          class="resolution-composer__send"
          color="primary"
          fab
          small
          :loading="disable_text"
          :disabled="disable_text"
          @click="enviaResolucao"
        >
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Chamado from "../domain/Chamado";
import { mapGetters } from "vuex";
import FotoUser from "./FotoUser.vue";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    FotoUser,
    VueEditor,
  },
  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    displayedResolucoes: function () {
      return this.resolucoes.filter((item) => this.temConteudoResolucao(item));
    },
  },
  props: ["id", "tecnicos", "limpa", "altura"],
  watch: {
    id: function (val) {
      if (val == null || val == "") {
        this.cancelAutoUpdate();
        this.resolucoes = [];
        this.cancelaEdicao();
        return;
      }
      this.cancelAutoUpdate();
      this.ativaAutoUpdate();
      this.carregaResolucoes(val);
    },
    limpa: function () {
      if (this.id == null || this.id == "") {
        this.cancelAutoUpdate();
        this.resolucoes = [];
        this.res = {
          text: "",
          datac: "",
          horac: "",
          idtec: "",
          idcha: "",
        };
        this.cancelaEdicao();
      }
    },
    resolucoes: function (val) {
      if (this.id == null || this.id == "") {
        this.$emit("getResolucoes", {
          resolucoes: val,
        });
        this.scrollBottom();
      }
    },
  },
  data: () => ({
    resolucoes: [],
    tempoTimer: 10000,
    timer: null,
    editingId: null,
    editingText: "",
    savingEdit: false,
    res: {
      text: "",
      datac: "",
      horac: "",
      idtec: "",
      idcha: "",
    },
    disable_text: false,
  }),
  mounted() {
    this.carregaResolucoes(this.id);
  },
  methods: {
    decodeMaybeBase64(value) {
      if (value == null || value === "") return "";
      if (typeof value !== "string") return value;

      const trimmed = value.trim();
      const normalized = trimmed.replace(/\s+/g, "");
      const looksLikeBase64 =
        normalized.length >= 8 &&
        /^[A-Za-z0-9+/=]+$/.test(normalized);

      if (!looksLikeBase64) return value;

      try {
        const padding = (4 - (normalized.length % 4 || 4)) % 4;
        const padded = normalized + "=".repeat(padding);
        const decoded = Vue.atob(padded);
        if (/[\x00-\x08\x0E-\x1F]/.test(decoded)) return value;
        return decoded || value;
      } catch (err) {
        return value;
      }
    },
    resolutionKey(item, idx) {
      return [
        item && item.id != null && item.id !== "" ? item.id : "no-id",
        item && item.idtec ? item.idtec : "no-tec",
        item && item.datac ? item.datac : "no-date",
        item && item.horac ? item.horac : "no-time",
        idx,
      ].join("-");
    },
    temConteudoResolucao(item) {
      if (!item) return false;
      const text = item.text == null ? "" : String(item.text);
      const cleaned = text
        .replace(/<p><br><\/p>/gi, "")
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
      return cleaned !== "";
    },
    enviaResolucao() {
      if (this.res.text == "") return;

      this.disable_text = true;
      var user = this.getUser;
      var res = {
        id: "",
        idcha: this.id,
        idtec: user.id,
        datac: Vue.getData(),
        horac: Vue.getHora(),
        text: Vue.btoa(this.res.text),
      };

      if (this.id == null || this.id == "") {
        res.text = this.decodeMaybeBase64(res.text);
        this.resolucoes.push(res);
        this.res.text = "";
        this.disable_text = false;
        return;
      }

      var vm = this;
      this.service = new Chamado(this.$resource);
      this.service.saveResolucoes(this.id, [res]).then(
        function (tmp) {
          res.text = this.decodeMaybeBase64(res.text);
          if (tmp.codigo > 0) {
            res.id = tmp.retvalue;
            this.resolucoes.unshift(res);
            this.res.text = "";
            setTimeout(() => {
              vm.scrollBottom();
            }, 1000);
          } else {
            Vue.Mensagem(
              this,
              "Nao deu certo",
              "Nao foi possivel inserir retorno"
            );
          }
          this.disable_text = false;
        },
        (err) => {
          Vue.Mensagem(this, "Nao deu certo", err);
          this.disable_text = false;
        }
      );
    },
    VueAtob(text) {
      return this.decodeMaybeBase64(text);
    },
    scrollBottom() {},
    carregaResolucoes(id) {
      if (this.id == null || this.id == "" || this.editingId != null) return;

      this.service = new Chamado(this.$resource);
      this.service.getResolucoes(id).then(
        function (tmp) {
          for (var i = 0; i < tmp.length; i++) {
            tmp[i].text = this.decodeMaybeBase64(tmp[i].text);
          }

          this.resolucoes = tmp;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    iniciaEdicao(item) {
      this.editingId = item.id;
      this.editingText = item.text;
    },
    cancelaEdicao() {
      this.editingId = null;
      this.editingText = "";
      this.savingEdit = false;
    },
    salvaEdicao(item) {
      if (this.editingText == null || this.editingText.trim() === "") return;

      this.savingEdit = true;
      const payload = [
        {
          id: item.id,
          idcha: item.idcha,
          idtec: item.idtec,
          datac: item.datac,
          horac: item.horac,
          text: Vue.btoa(this.editingText),
        },
      ];

      this.service = new Chamado(this.$resource);
      this.service.saveResolucoes(this.id, payload).then(
        function () {
          const idx = this.resolucoes.findIndex(
            (resolucao) => resolucao.id === item.id
          );
          if (idx > -1) {
            const atualizada = Object.assign({}, this.resolucoes[idx], {
              text: this.editingText,
            });
            this.$set(this.resolucoes, idx, atualizada);
          }
          this.cancelaEdicao();
        },
        (err) => {
          this.savingEdit = false;
          Vue.Mensagem(this, "Nao deu certo", err);
        }
      );
    },
    ativaAutoUpdate() {
      var vm = this;
      this.timer = setInterval(function () {
        vm.carregaResolucoes(vm.id);
      }, this.tempoTimer);
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
      this.timer = null;
    },
    excluirResolucao(i) {
      this.cancelaEdicao();
      if (this.id != null && this.id != "") {
        this.service = new Chamado(this.$resource);
        this.service.delResolucoes(i.id).then(
          function () {},
          () => {}
        );
      }

      let index = this.resolucoes.indexOf(i);
      if (index === -1 && i && i.id != null && i.id !== "") {
        index = this.resolucoes.findIndex((item) => item.id === i.id);
      }
      if (index > -1) this.resolucoes.splice(index, 1);
    },
  },
  destroyed() {
    this.cancelAutoUpdate();
  },
};
</script>
<style>
#editor_retorno,
#editor_retorno_edicao {
  height: auto;
}

.resolution-feed .v-card {
  border-radius: 18px !important;
  box-shadow: none !important;
}

.resolution-empty {
  padding: 22px 16px;
  text-align: center;
  color: #64748b;
  font-size: 0.92rem;
}

.resolution-message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  margin-bottom: 14px;
}

.resolution-message__avatar {
  flex: 0 0 auto;
}

.resolution-message__content {
  flex: 1 1 auto;
  min-width: 0;
}

.resolution-message__meta-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 6px;
}

.resolution-message__body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

.resolution-message__bubble {
  flex: 1 1 auto;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 18px 18px 18px 8px;
  background: rgba(248, 250, 252, 0.94);
}

.resolution-item__meta {
  color: #0f766e;
}

.resolution-message__menu {
  flex: 0 0 auto;
  background: rgba(15, 76, 92, 0.12) !important;
  color: #0f4c5c !important;
}

.resolution-message__dropdown {
  min-width: 180px;
}

.resolution-message__dropdown .v-list-item:hover {
  background: rgba(15, 76, 92, 0.08) !important;
}

.resolution-item__text {
  color: #334155;
  line-height: 1.62;
}

.resolution-item__text p:last-child {
  margin-bottom: 0;
}

.resolution-message--self {
  flex-direction: row-reverse;
}

.resolution-message--self .resolution-message__meta-row {
  justify-content: flex-end;
}

.resolution-message--self .resolution-message__bubble {
  background: linear-gradient(
    180deg,
    rgba(240, 253, 250, 0.98) 0%,
    rgba(236, 253, 245, 0.96) 100%
  );
  border-color: rgba(15, 118, 110, 0.18);
  border-radius: 18px 18px 8px 18px;
}

.resolution-edit {
  width: 100%;
}

.resolution-edit__editor .quillWrapper,
.resolution-edit__editor .ql-toolbar.ql-snow,
.resolution-edit__editor .ql-container.ql-snow,
.resolution-composer__editor .quillWrapper,
.resolution-composer__editor .ql-toolbar.ql-snow,
.resolution-composer__editor .ql-container.ql-snow {
  border-color: rgba(148, 163, 184, 0.22) !important;
  background: rgba(255, 255, 255, 0.96);
}

.resolution-edit__editor .ql-toolbar.ql-snow,
.resolution-composer__editor .ql-toolbar.ql-snow {
  border-radius: 18px 18px 0 0;
}

.resolution-edit__editor .ql-container.ql-snow,
.resolution-composer__editor .ql-container.ql-snow {
  border-radius: 0 0 18px 18px;
}

.resolution-edit__editor .ql-container,
.resolution-composer__editor .ql-container {
  height: auto !important;
}

.resolution-edit__editor .ql-editor {
  min-height: 96px;
  max-height: 220px;
  overflow-y: auto;
}

.resolution-edit__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 10px;
}

.resolution-composer {
  margin-top: 14px;
}

.resolution-composer__box {
  position: relative;
}

.resolution-composer__editor .ql-editor {
  min-height: 78px;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 64px;
}

.resolution-composer__send {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 38px !important;
  height: 38px !important;
  min-height: 38px !important;
  z-index: 3;
}
</style>
